import React from 'react';
import ReactDOM from 'react-dom';
import QuoteButton from "../components/quote-button";

var buttonList = document.querySelectorAll('.quote-button'); // returns NodeList
var buttonList = [...buttonList]; // converts NodeList to Array
buttonList.forEach(item => {
		
		const config = JSON.parse( item.getAttribute('config') );
		ReactDOM.render(
			<QuoteButton config={config} />,
			item,
		)
});